import { render } from "./InformeTrabajosSubsanadosCompanyia.vue?vue&type=template&id=7926cb90&scoped=true"
import script from "./InformeTrabajosSubsanadosCompanyia.vue?vue&type=script&lang=js"
export * from "./InformeTrabajosSubsanadosCompanyia.vue?vue&type=script&lang=js"

import "./InformeTrabajosSubsanadosCompanyia.vue?vue&type=style&index=0&id=7926cb90&scoped=true&lang=css"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7926cb90"]])

export default __exports__